export const theme = {
  colors: {
    white: "#FFFFFF",
    background: "#F5F5FA",
    term: "#74788B",
    title: "#18181B",
    loader: "#DDDDEE",
    errorButton: "#00740d",
    button: "#2366ed",
    buttonBorder: "#2366edab",
    buttonDisabledText: "#bbb",
    buttonDisabledBackground: "#eee",
    navigationHover: "#FCD420",
    navigationBackground: "#18181B",
    black: "#000000",
    //pagination colors:
    mystic: "#E4E6F0",
    waterloo: "#7E839A",
    mineShaft: "#333333",
    woodsmoke: "#18181B",
    pattensBlue: "#D6E4FF",
    scienceBlue: "#0044CC",
  },
  breakpoints: {
    mobile: "480px",
    small: "608px",
    medium: "767px",
    large: "1024px",
    extraLarge: "1199px",
  },
};
